import { MulticastChannel } from 'redux-saga';
import { fork, take } from 'typed-redux-saga';

import { DTMFAnalyser } from '../../../helpers/analysers/dtmf-analyser-goloom';
import { getAudioContext } from '../../../helpers/audio-context';
import { DTMFStateMachine } from '../dtmf/dtmf-state-machine';
import { rootParticipantListSaga } from '../dtmf/participant-list/sagas';

function* analyseTrackSaga({
    onRemoteTrackChannel,
}: {
    onRemoteTrackChannel: MulticastChannel<{ track: MediaStreamTrack }>;
}) {
    const audioCtx = getAudioContext();

    if (!audioCtx) {
        return;
    }

    const dtmfAnalyser = new DTMFAnalyser(audioCtx);
    const stateMachine = new DTMFStateMachine();

    yield* fork([stateMachine, stateMachine.start], dtmfAnalyser.onDtmfChar);

    let prevSourceNode: AudioNode | null = null;

    while (true) {
        const { track } = yield* take(onRemoteTrackChannel, '*');

        if (track.kind === 'audio') {
            if (prevSourceNode) {
                dtmfAnalyser.disconnect(prevSourceNode);
            }

            const nextSourceNode = audioCtx.createMediaStreamSource(new MediaStream([track.clone()]));

            dtmfAnalyser.connect(nextSourceNode);
            prevSourceNode = nextSourceNode;
        }
    }
}

export function* dtmfSaga(params: { onRemoteTrackChannel: MulticastChannel<{ track: MediaStreamTrack }> }) {
    yield* fork(analyseTrackSaga, params);
    yield* fork(rootParticipantListSaga);
}
